import {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import api from '../../services/api';
import Alert from '../../components/layout/Alert';
import Spinner from '../../components/button/Spinner';
import {cnpj, cpf} from 'cpf-cnpj-validator';

const img = require('../../assets/' + process.env.REACT_APP_LOGO);

export default function LoginForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const [document, setDocument] = useState('');
    const [password, setPassword] = useState('');
    const from = location.state?.from.pathname || '/';
    const [showAlert, setShowAlert] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');


    const login = () => {
        if (!cpf.isValid(document)) {
            if (!cnpj.isValid(document)) {
                setAlertMessage('Documento invalido');
                setShowAlert(true);
                return;
            }
        }
        setShowAlert(false);
        setShowSpinner(true);
        let login = document.match(/\d+/g).join('');
        api
            .post('auth/login', {
                login: login,
                password: password,
            })
            .then((response) => {
                sessionStorage.clear();
                sessionStorage.setItem('token', response.data.access_token);
                sessionStorage.setItem('user', JSON.stringify(response.data.user));
                setDocument('');
                setPassword('');
                navigate(from, {replace: true});
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    setAlertMessage('Login ou senha incorretos');
                    setShowAlert(true);
                    return;
                }
                setAlertMessage('Erro ao autenticar');
                setShowAlert(true);
                console.error(err);

            }).finally(() => setShowSpinner(false));
    };

    useEffect(() => {
        if (document !== undefined && document.trim() !== '') {
            let documentNumbers = document.match(/\d+/g);
            if (documentNumbers !== null) {
                setDocument(documentNumbers.join(''));
            } else {
                setDocument('');
                return;
            }
            documentNumbers = documentNumbers.join('');
            if (documentNumbers.length === 11) {
                setDocument(cpf.format(document));
                return;
            }
            setDocument(cnpj.format(document));
        }
    }, [document]);

    return (
        <>
            <img className="sm:hidden m-auto" src={img} alt="logo"/>
            <div className="m-auto bg-white rounded-md content-center w-full space-y-8 text-center">
                <form
                    className="pt-7 content-center m-auto max-w-md mt-50 space-y-6"
                    method="POST"
                    onSubmit={function (e) {
                        e.preventDefault();
                        login();
                    }}
                >
                    <h1 className="text-zinc-600 text-3xl font-semibold">Login</h1>
                    <div className="m-auto rounded-md -space-y-px">
                        <input
                            id="document"
                            name="document"
                            type="text"
                            value={document}
                            autoComplete="document"
                            required
                            className="mb-5 appearance-none  w-3/4 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md
                                 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder={'CPF/CNPJ'}
                            onChange={(e) => {
                                setDocument(e.currentTarget.value);
                            }}
                        />
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={password}
                            autoComplete="current-password"
                            required
                            className="appearance-none w-3/4 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md
                                 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                            placeholder="Senha"
                            onChange={(e) => {
                                setPassword(e.currentTarget.value);
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        className="m-auto bg-blue-500 font-bold text-white
                             w-3/4 flex justify-center py-2 px-4 border border-transparent text-sm
                             font-medium rounded-md  hover:bg-blue-600 focus:outline-none focus:ring-2
                             focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <span className="absolute  left-0 inset-y-0 flex items-center pl-3"/>
                        Acessar
                    </button>
                    <Alert
                        alertOpen={setShowAlert}
                        show={showAlert}
                        color="red"
                        message={alertMessage}
                    />
                    <div className="text-sm justify-center pb-7 text-zinc-600">
                        <Link to="/password/forgot"
                              className="block underline font-medium  hover:text-blue-900 pb-3">
                            Recuperar senha
                        </Link>
                        <Link to="/register" className="mt-5 underline font-medium hover:text-blue-900">
                            Primeiro acesso
                        </Link>
                    </div>
                    <Spinner loading={showSpinner}/>
                </form>
            </div>
        </>
    );
}
